import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LocalStorageService } from 'app/core/services/local-storage/local-storage.service';
import { AppConfig } from '../../../../app.config';
import { AuthService } from '../../../../core/services/auth/auth.service';

@Component({
  selector: 'Teranet-HangfireDashboard',
  templateUrl: './hangfire-dashboard.component.html'
})
export class HangfireDashboardComponent implements OnDestroy, OnInit {
  hangfireSrc: SafeResourceUrl;

  constructor(private localStorageService: LocalStorageService, private auth: AuthService, sanitizer: DomSanitizer) {
    this.hangfireSrc = sanitizer.bypassSecurityTrustResourceUrl(((AppConfig.settings != undefined) && AppConfig.settings) ? AppConfig.settings.settings.hangfireEndpoint : this.localStorageService.getItem('hangfireEndpoint'));
  }

  ngOnInit() {
    document.cookie = `Authenticated=${this.auth.Isauthenticated}; Path=/;`;
    document.cookie = `Role=${this.auth.currentUserValue.role}; Path=/;`;
    document.cookie = `TokenHeader=${this.localStorageService.getItem("accesstoken").split('.')[0]}; Path=/;`;
    document.cookie = `TokenPayload=${this.localStorageService.getItem("accesstoken").split('.')[1]}; Path=/;`;
    document.cookie = `TokenSignature=${this.localStorageService.getItem("accesstoken").split('.')[2]}; Path=/;`;
  }

  ngOnDestroy() {
    document.cookie = 'Authenticated=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'Role=; Path = /; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'TokenHeader=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'TokenPayload=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'TokenSignature=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}
